
const FamilyStatus = [
    'Не Одружений/-а',
    'Одружений/-а',
    'Розлучений/-а',
    'Вдівець/Вдова',
    'У стосунках',
    'Цифільний шлюб'
];

export default FamilyStatus;